const projects = [
    {
        position: 1,
        title: "Social Lens",
        keyWords: ["React JS", "Redux JS", "RapidApi", "Detector Face", "Detector Age", "Detector Emotion"],
        link: "https://github.com/IordanIonut/social-lens"
    },
    {
        position: 2,
        title: "MUsic PLay",
        keyWords: ["React JS", "Spring Boot", "Redux JS", "RapidApi", "MySQl", "Spring Security", "Authentication", "Maven", "Youtube", "Spotify", "Apple Music", "Shazam"],
        link: "https://github.com/IordanIonut/MUsic-PLay-Frontent"
    },
    {
        position: 3,
        title: "QuizMaster",
        keyWords: ["Android Studio", "XML", "Spring Boot", "Api", "MySQl", "Spring Security", "Authentication", "Grandle", "School", "Android App"],
        link: "https://github.com/IordanIonut/QuizMaster-Taker"
    },
    {
        position: 4,
        title: "MP3",
        keyWords: ["Android Studio", "RapidApi", "XML", "Api", "Android App", "Youtube", "Download"],
        link: "https://github.com/IordanIonut/MP3"
    },
    {
        position: 5,
        title: "Ior-Energy",
        keyWords: ["HTML", "CSS", "JS", "PHP", "Google Maps", "Scooters", "Rent", "Electric bicycles"],
        link: "https://github.com/IordanIonut/Ior-Energy"
    },
    {
        position: 6,
        title: "NumberMemory",
        keyWords: ["Java", "JavaFX", "XML", "Game", "Numbers"],
        link: "https://github.com/IordanIonut/NumberMemory"
    },
];

export default projects;
